define('models/AddressAutocompleteCollection',['underscore','jquery','backbone','app','router','ObjectCollection',
    'models/AddressAutocompleteModel',
    'models/GoogleAutocompleteCollection',
    'models/StoreAutocompleteCollection',
    'string','moment'
    ],
    function (_,$,Backbone,app,router,ObjectCollection,
        AddressAutocompleteModel,
        GoogleAutocompleteCollection,
        StoreAutocompleteCollection,
        S,moment) {
    //
    // Collection Address Autocomplete
    //

    var autocompleteTimeout = false,
        autocompleteTimeoutCollection,
        autocompleteLastKeyPressedTime = new Date(),
        autocompleteLastRequestedTime = new Date(),
        autocompleteLastRequested,
        BUFFER_DURATION = Modernizr.ios || Modernizr.android ? 1500 : 500,
        SHORT_IGNORE,
        SILENT_KEY; // ms waiting new key

    var AutocompleteCollectionPrototype = {
        name:'AutocompleteCollection',
        model:AddressAutocompleteModel,
        i:0,
        comparator:'rank',
        initialize:function(options){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,options);
            var _BUFFER_DURATION_CONF_ = '_ADDRESS_AUTOCOMPLETE_BUFFER_DURATION_';
            if(app.isMobile()){
                _BUFFER_DURATION_CONF_+='MOBILE_';
            }else{
                _BUFFER_DURATION_CONF_+='DESKTOP_';
            }
            BUFFER_DURATION = parseInt(app.c(_BUFFER_DURATION_CONF_,BUFFER_DURATION));
            SILENT_KEY = parseInt(app.c('_ADDRESS_AUTOCOMPLETE_SILENT_KEY_',1000));
            SHORT_IGNORE = parseInt(app.c('_ADDRESS_AUTOCOMPLETE_SHORT_IGNORE_',3));
            //
        },
        request:function(options){
            //
            var collection = this,
                keyTime = options.keyTime = options.keyTime || new Date(),
                timeDiff = moment().diff(autocompleteLastRequestedTime),
                timeKeyPressed = moment().diff(keyTime),
                inputEmpty, isManual, inputShort, reportDelay;

            options.input = S(options.input).trim().s;

            inputEmpty = options.input.length===0;
            inputShort = options.input.length<SHORT_IGNORE;
            isManual = options.mode === 'manual';

            //
            collection.options = options;
            autocompleteLastRequested = collection;

            clearTimeout(autocompleteTimeout);

            if(!(inputShort && isManual && inputEmpty)){
                // count only "real" valuable key pressed to start timer
                autocompleteLastKeyPressedTime = keyTime;

                var fastRequestInterval = timeDiff<BUFFER_DURATION,
                    fastKeyPressed = timeKeyPressed<BUFFER_DURATION/2,
                    longSilentKeyPressed = timeKeyPressed>BUFFER_DURATION*2;
                if(fastRequestInterval || fastKeyPressed || longSilentKeyPressed){
                    autocompleteTimeoutCollection = collection;
                    reportDelay = Math.max(BUFFER_DURATION-Math.min(timeDiff,timeKeyPressed),10);
                    autocompleteTimeout = setTimeout(function(){
                        if(autocompleteLastRequested == collection){
                            collection.request(options);
                        }else{
                        }
                    },reportDelay);
                    return "stop";
                }
                autocompleteLastRequestedTime = new Date();
            }


            // setup results from address
            collection.searchInCustomerAddress();

            //
            collection.maxLines = 0;
            //
            //
            if(options.type==='store'){
                //
                collection.maxLines = 999;
                var storeAutocompleteCollection = new StoreAutocompleteCollection();
                collection.listenTo(storeAutocompleteCollection,'sync',collection.updateStores);
                storeAutocompleteCollection.request(options);
            }else if(!inputEmpty && !isManual && !inputShort){
                var gaCollection = collection.googleAddressCollection = new GoogleAutocompleteCollection();
                collection.listenTo(gaCollection,'sync',collection.update);
                gaCollection.request(options);
            }else{
                collection.searchInCustomerStore();
                if(inputEmpty){
                    collection.searchInCustomerAddress(inputEmpty);
                }
                if(isManual){
                    if(inputEmpty && collection.size() == 0){
                        collection.trigger('fallback',collection);
                        return;
                    }
                    collection.addFallbackEntry();
                }
                collection.trigger('sync',collection);
            }
        },
        useTypeTypes:function(){ // filtre des types
            var useType = false, filterType = this.options.type;
            _(arguments).each(function(f){useType |= filterType == f})
            return useType != 0;
        },
        useTypeAddresses:function(){
            return this.useTypeTypes('all','address');
        },
        useTypeStores:function(){
            return this.useTypeTypes('all','store');
        },
        getInput:function(){
            return this.options.input;
        },
        getInputRegExp:function(start){
            start = start ? start:'';
            var input = this.getInput();
            return new RegExp(_.isNull(input) ? '(?!x)x' : start+escapeRegExp(input),'i');
        },

        searchInCustomerAddress:function(forceMatch){
            // match result from addresses
            var autoCompleteCollection = this,
                inputEmpty = autoCompleteCollection.getInput()=='',
            inputStartRegExp = autoCompleteCollection.getInputRegExp('( |^)');
            if(autoCompleteCollection.useTypeAddresses() && (autoCompleteCollection.options.action_context !== 'add')) {
                app.getAddresses().each(function (address) {
                    if (!address.isDeleted()) { // on ignore les adresses supprimées
                        var addressMatch = forceMatch ||
                            (!inputEmpty && (testMatch(inputStartRegExp,address.getAlias()) || testMatch(inputStartRegExp,address.getDescription())));
                        if (addressMatch) { // si la recherche match
                            var place = address.getPlace(),
                                postcode = address.getPostcodeModel(),
                                district = address.getDistrict(),
                                attr = {
                                    type: 'address',
                                    rank: 0,
                                    id_address: address.id,
                                    place_id: place ? place.id : 'address_' + address.id,
                                    description: address.get('description'),
                                    alias: address.get('alias'),
                                };
                            if (postcode) {
                                attr.id_postcode = postcode.id;
                            }
                            if (district) {
                                attr.id_district = district.id;
                            }

                            autoCompleteCollection.pushIfNotExists(attr)
                        }
                    }
                });
            }
        },
        searchInCustomerStore:function () {
            var autoCompleteCollection = this;
            if(autoCompleteCollection.useTypeStores()) {
                var customerStore = app.getCustomer().getStore();
                if(customerStore){
                    autoCompleteCollection.pushIfNotExists({rank:0,type: 'store', id_store:customerStore.id,description:customerStore.getName()})
                }
            }
        },
        addFallbackEntry:function(){
            var autoCompleteCollection = this;
            autoCompleteCollection.pushIfNotExists({
                type: 'address',
                rank: 0,
                id_address: 'exception_fallback',
                //place_id: 'exception_fallback',
                description: app.t('Saisir une nouvelle adresse','AddressAutocomplete'),
                usePlaceFetch:false
            })
        },
        onPlaceSync:function(placeModel){
            //var collection = this;
            //collection.update(collection.googleAddressCollection);
        },
        update:function(gaCollection){
            var autoCompleteCollection = this,
                usePlaceFetch = autoCompleteCollection.options.usePlaceFetch,
                firstSync = autoCompleteCollection.i == 0,
                id_district = autoCompleteCollection.options.id_district, // si on force un id_district, ignore_postcode (middle east)
                id_postcode = autoCompleteCollection.options.id_postcode, // si on force un id_postcode, ignore_postcode (middle east)
                useTypeAddresses = autoCompleteCollection.useTypeAddresses(),
                useTypeStores = autoCompleteCollection.useTypeStores(),
                customerAddresses = app.getAddresses(),
                buffer = _([]);
            autoCompleteCollection.i ++;

            // match result from autocomplete
            gaCollection.each(function(googleAutocompleteModel,rank){
                //if(googleAutocompleteModel.isLocalityMatching()) {
                    //
                    if (firstSync) {
                        autoCompleteCollection.listenTo(googleAutocompleteModel.getPlace(), 'sync', autoCompleteCollection.onPlaceSync);
                    }
                    if (useTypeAddresses && googleAutocompleteModel.isDeliveryAddress()) {
                        //
                        var address = customerAddresses.findWhere({deleted:0,place_id:googleAutocompleteModel.id}),
                            id_address = address ? address.id : 'new',
                            attributes = {
                                type: 'address',
                                rank: googleAutocompleteModel.getRank(),
                                place_id: googleAutocompleteModel.id,
                                id_address:id_address,
                                description: googleAutocompleteModel.getDescription(),
                                usePlaceFetch:usePlaceFetch,
                            };
                        if(id_district && id_postcode){
                            // cas middle east ou les codes postaux sont forcés
                            attributes.id_district = id_district;
                            attributes.id_postcode = id_postcode;
                        }
                        //
                        autoCompleteCollection.pushIfNotExists(attributes,buffer);
                        //
                    }
                    if (useTypeStores) {
                        googleAutocompleteModel.getStores().each(function (store) {
                            autoCompleteCollection.pushIfNotExists({
                                type: 'store',
                                rank: rank,
                                id_store: store.id,
                                place_id: googleAutocompleteModel.id,
                                description: store.getName(),
                                usePlaceFetch:usePlaceFetch,
                            });
                        },buffer);
                    }
                //}
            });
            //
            autoCompleteCollection.add(buffer.toArray());
            if(firstSync){
                autoCompleteCollection.trigger('sync',autoCompleteCollection);
            }
            //
        },
        updateStores:function(saCollection){
            // storeAutocomplete Update
            var autoCompleteCollection = this,
                buffer = _([]);
            saCollection.each(function(storeAutocomplete){
                autoCompleteCollection.pushIfNotExists(storeAutocomplete.toJSON(),buffer);
            });
            autoCompleteCollection.add(buffer.toArray());
            autoCompleteCollection.trigger('sync',autoCompleteCollection);
        },
        pushIfNotExists:function(attr,buffer){
            var autoCompleteCollection = this,
                options = _(attr).pick('type',attr.type === 'address' ? 'place_id':'id_store'),
                addressAutocompleteModel = autoCompleteCollection.findWhere(options),
                isException = /^exception_/.test(attr.id_address);

            if(addressAutocompleteModel && !isException) return false;
            if(buffer && buffer.findWhere(options)) return false;


            attr.displayDelay = autoCompleteCollection.options.displayDelay === true;
            attr.action = autoCompleteCollection.options.action;

            if(buffer){
                // le buffer permet d'ajouter un tableau de résultats
                buffer.push(attr);
            }else{
                addressAutocompleteModel = new AddressAutocompleteModel(attr);
                autoCompleteCollection.add(addressAutocompleteModel);//{type: 'address', place_id: address.getPlace().id})
            }
            return true;

        },
        cancel:function(){
            this.stopListening();
        },
        filterStores:function(){return this.where({type:'store'})},
        filterAddresses:function(){return this.where({type:'address'})}
    };

    function escapeRegExp(str){
        return str ? str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") : '';
    }

    function simplify(address){
        if(!address) return null; // utilisé dans les tests RegExp, null renvoi toujours false
        return S(address).latinise().stripPunctuation().s.toLowerCase();
    }

    function testMatch(regexp,string){
        return !!(simplify(string||'')||'').match(regexp);
    }

    var AutocompleteCollection = ObjectCollection
        .extend(AutocompleteCollectionPrototype);

    return AutocompleteCollection;
});
